module.exports = __webpack_public_path__ + "static/media/BAP8.9df88dd9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP8.png
 ** module id = 686
 ** module chunks = 0
 **/